export default __webpack_public_path__ + "static/harmonious-carousel-panel4-67904124c3ea200686ab17432da2249d0a47f65cda200c951c5378052b9d586f.png";